const NotificationType = {
  SUCCESS: 0,
  ERROR: 1,
  WARNING: 2,
  INFO: 3,
};

export default NotificationType;
